import { jsx as e } from "react/jsx-runtime";
//#region lib/Table/components/TableCell.tsx
var t = ({ element: t, children: n, attributes: r }) => {
	let { colspan: i, rowspan: a } = t?.properties || {};
	return /* @__PURE__ */ e("td", {
		...r,
		className: "py-2 px-2 border",
		colSpan: i ? Number(i) : void 0,
		rowSpan: a ? Number(a) : void 0,
		children: n
	});
};
t.displayName = "TableCell";
//#endregion
export { t as TableCell };
